import { Button, Col, Row } from 'antd';
import { Link } from 'react-router-dom';

import actionBottonsArray from './actionButtonsArray';




/**
 * @description bu komponent komitee adina gore butonlarin gosterilmesini saglar.
 * @see actionButtonsArray - burada hangi asamada hangi butonlarin gosterilecegi bilgisi tutulur.
 * @param {number} buttonType - button type
 * @param {boolean} encyclopediaUnit - encyclopedia unit (true or false)
 * @param {string} committee - committee
 * @param {number} step - step
 * @param {number} offerId - offer id
 * @returns {React.ReactNode}
 */

function ActionButtons({ buttonType, encyclopediaUnit = false, committee, step, offerId }) {
  return (
    <Row gutter={24}>
      {actionBottonsArray({ encyclopediaUnit })[buttonType].map((button) => (
        <Col
          key={button.label}
          span={button.col}
        >
          <Button block>
            <Link to={`/telif-sonrasi/${button.routePath}/${step}/${committee}/${offerId}/${button.decicionPath}`}>{button.label}</Link>
          </Button>
        </Col>
      ))}
    </Row>
  );
}
export default ActionButtons;
